module.exports = {
    api_port: "",
    website_port: "",
    api_path: "https://wetbot.space",
    root_path: "https://wetbot.space",
    botId: "801814636168740914",
    supportServerInvite: "https://discord.gg/9ujyUb5vYy",
    redirect_uri: "https://discord.com/oauth2/authorize?client_id=801814636168740914&response_type=code&redirect_uri=https%3A%2F%2Fwetbot.space%2Flogin&scope=identify+guilds",
    emojis: {
        badges: {
            ActiveDeveloper: "<:ActiveDeveloper:1131931983765831820>",
            BugHunterLevel1: "<:Bughunter:1131932020314996887>",
            BugHunterLevel2: "<:GoldBughunter:1131932022911270922>",
            HypeSquadOnlineHouse1: "<:HypeSquadBravery:1131932024744198219>",
            HypeSquadOnlineHouse2: "<:HypeSquadBrilliance:1131932017869729822>",
            HypeSquadOnlineHouse3: "<:HypeSquadBalance:1131932014669467669>",
            CertifiedModerator: "<:CertifiedModerator:1131932137537404949>",
            Partner: "<:PartneredServerOwner:1131932027474673766>",
            Staff: "<:DiscordStaff:1131933387284819979>",
            VerifiedDeveloper: "<:VerifiedDeveloper:1131931984881520741>",
            Hypesquad: "<:HypeSquadEvents:1131936924114878516>",
            PremiumEarlySupporter: "<:PremiumEarlySupporter:1131931988211802162>",
            Booster1Month: "<:Booster1Month:1131931992519360613>",
            Booster2Months: "<:Booster2Months:1131931996956921876>",
            Booster3Months: "<:Booster3Months:1131931999590961182>",
            Booster6Months: "<:Booster6Months:1131932001469997188>",
            Booster9Months: "<:Booster9Month:1131932004221472899>",
            Booster12Months: "<:Booster12Months:1131932005622366228>",
            Booster15Months: "<:Booster15Months:1131932007040032888>",
            Booster18Months: "<:Booster18Months:1131932009917337680>",
            Booster24Months: "<:Booster24Months:1131932012203212811>",
            ServerOwner: "<:ServerOwner:1131932030268088340>",
            WetbotDeveloper: "<:wetbot:1010529119018156133>",
            DonaterLvl1: "<:Donater1Lvl:1131934861796585554>",
            DonaterLvl2: "<:Donater2Lvl:1131934860102090853>",
            DonaterLvl3: "<:Donater3Lvl:1131934865017806918>",
            Administrator: "<a:ADMIN:957195477504389142>"
        },
        XP100Booster: "<:XP_boost:1005831798263136326>",
        YES: "<:YES:1017018549438529581>",
        NO: "<:NO:1017018588994998346>",
        DONE: "<a:DONE:957226105906016316>",
        XP: "<:xp:1005856357150359664>",
        RP: "<:RP:1006200288933335081>",
        BOOSTER: "<a:BOOST:957199538496618516>",
        next: "<:arrowRight:1005828999647342642>",
        previous: "<:arrowLeft:1005828997982195753>",
        plus: "<:PLUS:1012990107143385159>",
        unknown: "1005843632038887437",
        VK: "<:VK:955846693574836225>",
        TikTok: "<:TikTok:955847914817744937>",
        Instagram: "<:Instagram:955848158058016788>",
        Steam: "<:Steam:955848368746274916>",
        male: "<:male:955849421218783242>",
        female: "<:female:955849419633340427>",
        purplebutterflies: "<a:MARRY:955856960702545921>",
        blackFire: "<a:BLACKFIRE:957199184090501140>",
        UP: "<a:UP:1004400227085721722>",
        DOWN: "<a:DOWN:1004400224720134155>",
        arrowLeft2: "<:arrowLeft2:1017020174077001748>",
        arrowLeft: "<:arrowLeft:1017020229571850251>",
        arrowRight: "<:arrowRight:1017020214094856243>",
        arrowRight2: "<:arrowRight2:1017020193425338468>",
        RELOAD: "<:RELOAD:1005848992313266216>",
        activities: "<:activities:1005856343141384264>",
        trophies: "<:trophies:1005856344718450719>",
        gender: "<:gender:1005856346031263804>",
        watch: "<:watch:1005856347285364746>",
        achievements: "<:achievments:1005856348703051836>",
        top: "<:top:1005856350254932028>",
        shop: "<:shop:1005856351601315860>",
        invite: "<:invite:1005856352930898011>",
        inventory: "<:inventory:1005856354445045790>",
        profile: "<:profile:1005856355791405076>",
        upvote: "<:upvote:1005856358492553266>",
        cookie: "<:cookie:1005856359503368233>",
        wormhole: "<:wormhole:1005856361076228096>",
        giveaway: "<:giveaway:1005856362632323112>",
        quests: "<:quests:1005856364578488371>",
        bump: "<:bump:1005856365996159107>",
        like: "<:like:1005856368600809552>",
        message: "<:message:1005856370152702014>",
        mic: "<:mic:1005856371926904872>",
        exc: "<:exc:1005858944587157674>",
        block: "<:block:1005859695619215370>",
        random: "<:random:1005865190618828910>",
        coin: "<:coin:1005871356128268349>",
        roles: "<:roles:1005872068031696998>",
        fishing: "<:fishing:1005872649186070598>",
        box: "<:box:1005873095615205436>",
        smile: "<:smile:1005873250087227393>",
        numbers: "<:1234:1005873347860643982>",
        tada: "<:tada:1005873464822997115>",
        O: "<:O_:1005873566069309480>",
        X: "<:X_:1005873928931135508>",
        rho: "<:__:1005874053770379354>",
        loupe: "<:loupe:1005875277693472838>",
        vc: "<:vc:1005879082946408498>",
        question: "<:q_:1005879832569204908>",
        fire: "<:fire:1006197138784522320>",
        balloon: "<:balloon:1006199007187570738>",
        medal: "<:medal:1006201719870468126>",
        recipe: "<:recipe:1006202068761067581>",
        scroll: "<:scroll:1006202070111621202>",
        stop: "<:stop:1006203256244031528>",
        pen: "<:pen:1012990423171600404>",
        dol: "<:dol:1027959954847567923>",
        style: "<:style:1012991606258946058>",
        open: "<:open:1012992281013395476>",
        craft: "<:craft:1012994142458085376>",
        gear: "<:gear:1012996055836663869>",
        use: "<:use:1012998368500400130>",
        on: "<:ON:1017018609802956820>",
        off: "<:OFF:1017018627649703946>",
        mining: "<:mining:1027959035544211526>",
        ring: "<:ring:1067804964803575808>",
        star: "<:star:1126077530651250760>",
        new: "<:new_1:1126077579720396860><:new_2:1126077640768507967>",
        premium: "<:premium:1126092326209605674>",
        beta: "<:beta_1:1126090828612386927><:beta_2:1126090908455157860><:beta_3:1126090966328168478>",
        seasonXP: "<:seasonXP:1126096401886101505>",
        seasonLevel: "<:seasonLevel:1126096468554555453>",
        discordIcon: "<:DiscordIcon:1131945682857627719>",
        online_mobile: "<:online_mobile:1172189469030498394>",
        idle_mobile: "<:idle_mobile:1172189472406909028>",
        dnd_mobile: "<:dnd_mobile:1172189473799409754>",
        offline_mobile: "<:offline_mobile:1172189476181782539>",
        online_web: "<:online_web:1172189478576726036>",
        idle_web: "<:idle_web:1172189481193975808>",
        dnd_web: "<:dnd_web:1172189482611646504>",
        offline_web: "<:offline_web:1172189484129976423>",
        dnd_desktop: "<:dnd_desktop:1172189486558486630>",
        offline_desktop: "<:offline_desktop:1172189489460936775>",
        idle_desktop: "<:idle_desktop:1172189491251904542>",
        online_desktop: "<:online_desktop:1172189493776875562>",
        leave: "<:leave:1177515932650848286>",
        join: "<:join:1177515934324363295>"
    }
};